import React, { FC } from "react";
import Svg, { G, Circle, Path } from "react-native-svg";
import { ICustomSvgProps } from "./AngryIcon";

const OkIcon: FC<ICustomSvgProps> = (props) => {
  return (
    <Svg width={props.width} height={props.height} viewBox="0 0 313 313">
      <G transform="translate(-52.3109, -44.8266)">
        <Circle
          cx="208.495"
          cy="201.01"
          r="156.184"
          fill={props.color || "rgb(245,192,65)"}
        />
      </G>
      <G transform="translate(-59.3665, -36.7654)">
        <G transform="matrix(-0.6192, 0.59853, -0.59853, -0.6192, 158.895, 158.956)">
          <Circle
            cx="0"
            cy="0"
            r="15.908"
            stroke={props.strokeColor || "black"}
            strokeWidth="15.1"
          />
        </G>
        <G transform="matrix(-0.6192, 0.59853, -0.59853, -0.6192, 272.205, 161.124)">
          <Circle
            cx="0"
            cy="0"
            r="15.908"
            stroke={props.strokeColor || "black"}
            strokeWidth="15.1"
          />
        </G>
      </G>
      <G transform="translate(-863.844, -30.7654)">
        <Path
          d="M944.877,230.995L1095.18,230.995"
          fill="none"
          stroke={props.strokeColor || "black"}
          strokeWidth="20"
        />
      </G>
    </Svg>
  );
};

export default OkIcon;
